<div>
  <form novalidate [formGroup]="fluidForm()">
    <h6 class="card-title">Fluid</h6>

    <div class="flex-column" style="padding-bottom:10px">

      <!-- For each Fluid Row  -->
      <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
        <div class="form-group  flex-50">
          <label>Fluid System</label>
          <input class="k-textbox form-control" readonly value="{{fluidData()?.FluidSystem}}">
        </div>
        <div class="form-group  flex-50">
          <label>Fluid Quantity bbl/ft</label>
          <input type="text" class="k-textbox form-control" readonly value="{{fluidData()?.WaterVolume | safeNumber:'1.0-0'}}">
        </div>
      </div>

      <!-- For each Fluid Row  -->
      <div class="flex-full flex-align-start flex-gap-10">
        <div class="form-group  flex-50" style="padding-right:40px; padding-left:10px;">
          <label>Slick Water Percent</label>
          <kendo-svgicon [icon]="icons.questionSolid" class="ms-1 inline-help-button" (click)="onClickTooltipIcon()"></kendo-svgicon>
          <!-- <input class="k-textbox form-control" value="{{fluidData?.SlickWaterPct | percent}}"> -->
          <kendo-numerictextbox formControlName="SlickWaterPct" class="text-right form-control" [format]="'p1'" [step]=".01" [min]="0" [max]="1" [spinners]="false" [autoCorrect]="true">
          </kendo-numerictextbox>
        </div>
        <div class="form-group  flex-50" style="margin-left: -5px;">
          <label>Gel Weight for LG and XL</label>
          <input type="text" class="k-textbox form-control" readonly value="{{fluidData()?.GelWeight | safeNumber:'1.0-0'}}">
        </div>
      </div>

      <!-- For each Fluid Row  -->
      <div class="flex-full flex-align-start flex-gap-10">
        <div class="form-group flex-50" style="padding-right:40px; padding-left:10px;">
          <label>Linear Gel Percent</label>
          <kendo-svgicon [icon]="icons.questionSolid" class="ms-1 inline-help-button" (click)="onClickTooltipIcon()"></kendo-svgicon>
          <kendo-numerictextbox formControlName="LinearGelPct" class="text-right form-control" [format]="'p1'" [step]=".01" [min]="0" [max]="1" [spinners]="false" [autoCorrect]="true">
          </kendo-numerictextbox>
        </div>
        <div class="form-group flex-50">
          <label>Frac Water Volume</label>
          <input type="text" class="k-textbox form-control" readonly value="{{fluidData()?.FracWaterVolume | safeNumber:'1.0-2'}}">
        </div>
      </div>

      <!-- For each Fluid Row  -->
      <div class="flex-full flex-align-start flex-gap-10">
        <div class="form-group flex-50" style="padding-right:40px; padding-left:10px;">
          <label>Cross Link Percent</label>
          <kendo-svgicon [icon]="icons.questionSolid" class="ms-1 inline-help-button" (click)="onClickTooltipIcon()"></kendo-svgicon>
          <kendo-numerictextbox formControlName="CrossLinkPct" class="text-right form-control" [format]="'p1'" [step]=".01" [min]="0" [max]="1" [spinners]="false" [autoCorrect]="true">
          </kendo-numerictextbox>
        </div>
        <div class="form-group flex-50">
          <label>Pump Down Water Volume</label>
          <input class="k-textbox form-control" readonly value="{{fluidData()?.PumpdownWaterVolume}}">
        </div>
      </div>

      <!-- For each Fluid Row  -->
      <div class="flex-full flex-align-start flex-gap-10">
        <div class="form-group flex-50" style="padding-right:40px; padding-left:10px;">
          <label>HVFR Percent</label>
          <kendo-svgicon [icon]="icons.questionSolid" class="ms-1 inline-help-button" (click)="onClickTooltipIcon()"></kendo-svgicon>
          <kendo-numerictextbox formControlName="HvfrPct" class="text-right form-control" [format]="'p1'" [step]=".01" [min]="0" [max]="1" [spinners]="false" [autoCorrect]="true">
          </kendo-numerictextbox>
        </div>
      </div>
    </div>
  </form>
</div>